// @flow
import React, { Component, Fragment } from 'react'
import _ from 'lodash'
import { translateFunc, translations } from '../../shared/localize'
import StatisticsCell, { TYPES } from './StatisticsCell'
import { Cell } from '../MainTable'

type Props = {|
  statistics: Array<Object>
|}

export default class StatisticsCells extends Component<Props> {
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.provider_short_translations)
  }

  renderTd(statistics: Array<Object>, className: string, property: string, type: string) {
    return (
      <Cell alignRight key={property} className={`nowrap ${className}`}>
        {_.map(statistics, (statistic, index: number) => (
          <StatisticsCell key={index} statistics={statistic} property={property} type={type} />
        ))}
      </Cell>
    )
  }

  render() {
    // uses {_: ''} in case of an not found translation
    const statistics = _.sortBy(this.props.statistics, (s) =>
      this.t(s.providerName, { _: '' })
    ).reverse()

    return (
      <Fragment>
        {this.renderTd(statistics, 'spent', 'spent', TYPES.NUMBER)}
        {this.renderTd(statistics, 'impressions', 'impressions', TYPES.NUMBER)}
        {this.renderTd(statistics, 'clicks', 'clicks', TYPES.NUMBER)}
        {this.renderTd(statistics, 'ctr', 'ctr', TYPES.PERCENT)}
        {this.renderTd(statistics, 'cpc', 'cpc', TYPES.NUMBER)}
        {this.renderTd(statistics, 'cpm', 'cpm', TYPES.NUMBER)}
        {this.renderTd(statistics, 'goals', 'goals', TYPES.NUMBER)}
        {this.renderTd(statistics, 'goal_price', 'goalPrice', TYPES.NUMBER)}
        {this.renderTd(statistics, 'goal_percentage', 'goalPercentage', TYPES.PERCENT)}
      </Fragment>
    )
  }
}
